import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import AppRoutes from 'routes/AppRoutes';
import ToastContainer from 'components/common/Toast';
import PWAUpdatePrompt from 'components/common/PWAUpdatePrompt';
import { restoreSession } from 'features/auth/authThunks';
import { tokenService } from 'services/api/tokenService';

/**
 * Root application component. On mount it attempts to restore the session if a
 * token exists in storage (handled by the auth slice's "restoring" status so
 * the router shows a splash instead of flashing the login screen).
 */
const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (tokenService.hasSession()) {
      dispatch(restoreSession());
    }
  }, [dispatch]);

  return (
    <div className="kvo-app">
      <PWAUpdatePrompt />
      <AppRoutes />
      <ToastContainer />
    </div>
  );
};

export default App;
